export const getOrganizationDomain = state => {
  const domain = state.organization.availableDomains && state.organization.availableDomains[0];
  if (domain) {
    if (domain.includes('@')) return domain;
    return `@${domain}`;
  }
  return '';
};

// const organizationDomain = useSelector(state => {
//   const domain = state.organization.availableDomains[0];
//   if (domain) {
//     if (domain.includes('@')) return domain;
//     return `@${domain}`;
//   }
//   return '';
// });
